(ns frontend.ui.component.lp-portal.report.esg.gresb
  (:require
   [potpuri.core :as potpuri]))

(def gresb-configs
  [{:key   "none"
    :label "Not certified"
    :image nil}
   {:key   "gresb-default"
    :label "Gresb vertical"
    :image "https://static.zapflow.com/app/img/lp_portal/gresb/GRESB_vert.png"}
   {:key   "gresb-rating-0"
    :label "Gresb rating 0"
    :image "https://static.zapflow.com/app/img/lp_portal/gresb/rating/RE_00.png"}
   {:key   "gresb-rating-1"
    :label "Gresb rating 1"
    :image "https://static.zapflow.com/app/img/lp_portal/gresb/rating/RE_01.png"}
   {:key   "gresb-rating-2"
    :label "Gresb rating 2"
    :image "https://static.zapflow.com/app/img/lp_portal/gresb/rating/RE_02.png"}
   {:key   "gresb-rating-3"
    :label "Gresb rating 3"
    :image "https://static.zapflow.com/app/img/lp_portal/gresb/rating/RE_03.png"}
   {:key   "gresb-rating-4"
    :label "Gresb rating 4"
    :image "https://static.zapflow.com/app/img/lp_portal/gresb/rating/RE_04.png"}
   {:key   "gresb-rating-5"
    :label "Gresb rating 5"
    :image "https://static.zapflow.com/app/img/lp_portal/gresb/rating/RE_05.png"}])

(def gresb-configs-2023
  [{:key   "none"
    :label "Not certified"
    :image nil}
   {:key   "gresb-default"
    :label "Gresb vertical"
    :image "https://static.zapflow.com/app/img/lp_portal/gresb/GRESB_vert.png"}
   {:key   "gresb-rating-2-2023"
    :label "Gresb rating 2"
    :image "https://static.zapflow.com/app/img/lp_portal/gresb/rating/2023/RE_02_2023.png"}
   {:key   "gresb-rating-3-2023"
    :label "Gresb rating 3"
    :image "https://static.zapflow.com/app/img/lp_portal/gresb/rating/2023/RE_03_2023.png"}
   {:key   "gresb-rating-4-2023"
    :label "Gresb rating 4"
    :image "https://static.zapflow.com/app/img/lp_portal/gresb/rating/2023/RE_04_2023.png"}])

(def gresb-configs-2024
  [{:key   "none"
    :label "Not certified"
    :image nil}
   {:key   "gresb-default"
    :label "Gresb vertical"
    :image "https://static.zapflow.com/app/img/lp_portal/gresb/GRESB_vert.png"}
   {:key   "gresb-rating-4-2024"
    :label "Gresb rating 4"
    :image "https://static.zapflow.com/app/img/lp_portal/gresb/rating/2024/2024_RE_04.png"}
   {:key   "gresb-rating-5-2024"
    :label "Gresb rating 5"
    :image "https://static.zapflow.com/app/img/lp_portal/gresb/rating/2024/2024_RE_05.png"}])

(def gresb-configs-2025
  [{:key   "none"
    :label "Not certified"
    :image nil}
   {:key   "gresb-default"
    :label "Gresb vertical"
    :image "https://static.zapflow.com/app/img/lp_portal/gresb/GRESB_vert.png"}
   {:key   "gresb-rating-4-2025"
    :label "Gresb rating 4"
    :image "https://static.zapflow.com/app/img/lp_portal/gresb/rating/2025/GRESB_Stars_2025_RE_04_Color.png"}
   {:key   "gresb-rating-5-2025"
    :label "Gresb rating 5"
    :image "https://static.zapflow.com/app/img/lp_portal/gresb/rating/2025/GRESB_Stars_2025_RE_05_Color.png"}])

(def green-building-configs
  [{:key   "breeam"
    :image "https://static.zapflow.com/images/logos/BREEAM_logo.png"}
   {:key   "dgnb"
    :image "https://static.zapflow.com/images/logos/dgnb.jpg"}
   {:key   "usgbc"
    :image "https://static.zapflow.com/images/logos/U.S._Green_Building_Council_logo.png"}])

(def EPC-configs
  [{:key   "EPC_A"
    :image "https://static.zapflow.com/images/logos/EPC_A.png"}
   {:key   "EPC_B"
    :image "https://static.zapflow.com/images/logos/EPC_B.png"}
   {:key   "EPC_C"
    :image "https://static.zapflow.com/images/logos/EPC_C.png"}
   {:key   "EPC_D"
    :image "https://static.zapflow.com/images/logos/EPC_D.png"}
   {:key   "EPC_E"
    :image "https://static.zapflow.com/images/logos/EPC_E.png"}
   {:key   "EPC_F"
    :image "https://static.zapflow.com/images/logos/EPC_F.png"}
   {:key   "EPC_G"
    :image "https://static.zapflow.com/images/logos/EPC_G.png"}
  ])

(def portfolio-snapshot-configs
  [{:key   "PROPERTIES"
    :image "https://static.zapflow.com/images/logos/properties_icon.png"}
   {:key   "PHYSICAL OCCUPANCY"
    :image "https://static.zapflow.com/images/logos/physical_occupancy_icon.png"}
   {:key   "AVERAGE APARTMENT SIZE"
    :image "https://static.zapflow.com/images/logos/average_apt_size_icon.png"}
   {:key   "NIY"
    :image "https://static.zapflow.com/images/logos/yield_icon.png"}
   {:key   "EY"
    :image "https://static.zapflow.com/images/logos/yield_icon.png"}
   {:key   "APARTMENTS"
    :image "https://static.zapflow.com/images/logos/apartments_icon.png"}
   {:key   "OF GAV IN CAPITALS"
    :image "https://static.zapflow.com/images/logos/of_gav_in_capital_icon.png"}
   {:key   "AVERAGE RENT"
    :image "https://static.zapflow.com/images/logos/average_rent_icon.png"}
   {:key   "OF PORTFOLIO INCOME-GENERATING"
    :image "https://static.zapflow.com/images/logos/of_portfolio_icon.png"}])

(def hotels-portfolio-snapshot-configs
  [{:key   "PROPERTIES"
    :image "https://static.zapflow.com/images/logos/properties_icon.png"}
   {:key   "WAULT"
    :image "https://static.zapflow.com/images/logos/physical_occupancy_icon.png"}
   {:key   "REVENUE PER AVAILABLE ROOM"
    :image "https://static.zapflow.com/images/logos/average_apt_size_icon.png"}
   {:key   "NIY"
    :image "https://static.zapflow.com/images/logos/yield_icon.png"}
   {:key   "EY"
    :image "https://static.zapflow.com/images/logos/yield_icon.png"}
   {:key   "ROOMS"
    :image "https://static.zapflow.com/images/logos/apartments_icon.png"}
   {:key   "OF GAV IN METROPOLITAN CITIES"
    :image "https://static.zapflow.com/images/logos/of_gav_in_capital_icon.png"}
   {:key   "NOI"
    :image "https://static.zapflow.com/images/logos/average_rent_icon.png"}
   {:key   "OF PORTFOLIO INCOME-GENERATING"
    :image "https://static.zapflow.com/images/logos/of_portfolio_icon.png"}])

(def financial-snapshot-configs
  [{:key "GAV"                        
    :image "https://static.zapflow.com/images/logos/gav_nav_icon.png"}
   {:key "NAV"                       
    :image "https://static.zapflow.com/images/logos/gav_nav_icon.png"}
   {:key "LTGAV"                    
    :image "https://static.zapflow.com/images/logos/ltgav_icon.png"}
   {:key "LTV"                     
    :image "https://static.zapflow.com/images/logos/ltgav_icon.png"}
   {:key "TOTAL RETURN (TTM)"         
    :image "https://static.zapflow.com/images/logos/return_icon.png"}
   {:key "DISTRIBUTION YIELD ON NAV (TTM)" 
    :image "https://static.zapflow.com/images/logos/distribution_icon.png"}])

(def esg-snapshot-configs
  [{:key "EPC A-C BY GAV"
    :image "https://static.zapflow.com/images/logos/epc_icon.png"}
   {:key "OF ASSETS CERTIFIED"
    :image "https://static.zapflow.com/images/logos/cert_icon.png"}
   {:key "CO2 EMISSIONS CO2e/m²"
    :image "https://static.zapflow.com/images/logos/emissions_icon.png"}
   {:key "GRESB"
    :image "https://static.zapflow.com/images/logos/gresb_icon.png"}])

(def hotels-esg-snapshot-configs
  [{:key "EU TAXONOMY ALIGNMENT"
    :image "https://static.zapflow.com/images/logos/eu_taxonomy.png"}
   {:key "OF PROPERTIES HOLD A GREEN BUILDING CERTIFICATION"
    :image "https://static.zapflow.com/images/logos/cert_icon.png"}
   {:key "KGCO2E/M², OPERATIONAL GHG EMISSIONS"
    :image "https://static.zapflow.com/images/logos/emissions_icon.png"}
   {:key "GRESB, STANDING INVESTMENT BENCHMARK"
    :image "https://static.zapflow.com/images/logos/gresb_icon.png"}])

(def lookup
  (->> (concat gresb-configs gresb-configs-2023
               gresb-configs-2024 gresb-configs-2025
               portfolio-snapshot-configs hotels-portfolio-snapshot-configs
               financial-snapshot-configs
               esg-snapshot-configs hotels-esg-snapshot-configs)
       (potpuri/index-by :key)))

(defn get-image
  [gresb-key]
  (->> (get lookup gresb-key)
       :image))
